import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import './PageDeleter.css';
import ConfirmationModal from "../../../components/ConfirmationModal/ConfirmationModal"; // Ensure you have this CSS file for styling

function PageDeleter() {
    const [data, setData] = useState([]);
    const [modalIsOpen, setIsOpen] = useState(false);
    const [selectedId, setSelectedId] = useState(null);
    const [alert, setAlert] = useState({ show: false, message: '', type: '' });
    const alertTimeout = useRef(null);

    const jwtToken = localStorage.getItem('jwtToken');
    const axiosConfig = {
        headers: {
            'Authorization': `Bearer ${jwtToken}`
        }
    };
    useEffect(() => {
        axios.get(`${process.env.REACT_APP_API_BASE_URL}/GetAllPageFooter`, axiosConfig)
            .then(response => {
                if (response.data && response.data.data) {
                    setData(response.data.data);
                }
            })
            .catch(error => console.error('Error fetching data:', error));
    }, []);

    const showAlert = (message, type) => {
        setAlert({ show: true, message, type });
        alertTimeout.current = setTimeout(() => {
            setAlert({ show: false, message: '', type: '' });
        }, 5000);
    };

    useEffect(() => {
        return () => {
            if (alertTimeout.current) {
                clearTimeout(alertTimeout.current);
            }
        };
    }, []);

    function handleDelete() {
        axios.put(`${process.env.REACT_APP_API_BASE_URL}/DeletePage`, { id: selectedId }, axiosConfig)
            .then(response => {
                if (response.data && response.data.success) {
                    const updatedData = data.filter(item => item.id !== parseInt(selectedId, 10));
                    setData(updatedData);
                    setSelectedId(null);
                    showAlert('გვერდი წარმატებით წაიშალა', 'success');
                } else {
                    showAlert('დაფიქსირდა შეცდომა, ცადეთ მოგვინაებით', 'error');
                }
            })
            .catch(error => {
                showAlert('დაფიქსირდა შეცდომა, ცადეთ მოგვინაებით', 'error');
            });
        setIsOpen(false);
    }

    return (
        <div className="page-deleter-container">
            <select
                className="page-deleter-dropdown"
                onChange={(e) => setSelectedId(e.target.value)}
                value={selectedId}
            >
                <option value="">აირჩიეთ გვერდი</option>
                {data.map(item => (
                    <option key={item.id} value={item.id}>{item.name}</option>
                ))}
            </select>
            <button
                className="page-deleter-button"
                onClick={() => setIsOpen(true)}
                disabled={!selectedId}
            >
                წაშლა
            </button>

            <ConfirmationModal
                isOpen={modalIsOpen}
                onRequestClose={() => setIsOpen(false)}
                onConfirm={handleDelete}
            />

            {alert.show && (
                <div className={`custom-alert ${alert.type}`}>
                    {alert.message}
                </div>
            )}
        </div>
    );
}

export default PageDeleter;
